export type PacketaPoint = {
    id?: string | number;
    name?: string;
    place?: string;
    city?: string;
    street?: string;
    zip?: string;
};

declare global {
    interface Window {
        Packeta?: {
            Widget?: {
                pick: (
                    apiKey: string,
                    callback: (point: PacketaPoint | null) => void,
                    options?: Record<string, unknown>,
                ) => void;
            };
        };
        __webdoPacketaWidgetLoading?: Promise<boolean>;
    }
}

export function packetaPointDisplayName(point: PacketaPoint): string | null {
    const parts = [point.name, point.place, point.street, point.city, point.zip]
        .filter((value): value is string => typeof value === "string" && value.trim() !== "")
        .map((value) => value.trim());

    return parts.length > 0 ? Array.from(new Set(parts)).join(", ") : null;
}

export async function ensurePacketaWidget(): Promise<boolean> {
    if (typeof window === "undefined") {
        return false;
    }

    if (window.Packeta?.Widget) {
        return true;
    }

    if (window.__webdoPacketaWidgetLoading) {
        return await window.__webdoPacketaWidgetLoading;
    }

    window.__webdoPacketaWidgetLoading = new Promise<boolean>((resolve) => {
        const script = document.createElement("script");
        script.src = "https://widget.packeta.com/v6/www/js/library.js";
        script.async = true;
        script.onload = () => resolve(Boolean(window.Packeta?.Widget));
        script.onerror = () => resolve(false);
        document.head.appendChild(script);
    });

    return await window.__webdoPacketaWidgetLoading;
}
